import { render } from "./ShoppingCarDetailsCard.vue?vue&type=template&id=33d8ccb4&scoped=true"
import script from "./ShoppingCarDetailsCard.vue?vue&type=script&lang=js"
export * from "./ShoppingCarDetailsCard.vue?vue&type=script&lang=js"

import "./ShoppingCarDetailsCard.vue?vue&type=style&index=0&id=33d8ccb4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d8ccb4"]])

export default __exports__